<template>
  <section>
    <v-layout wrap row>
      <v-flex>
        <v-layout row>
          <v-flex xs5>
            Voted users total count: <b>{{getStepOneAttendeesCountIndividual}}</b><br>
            Votes total count: <b>{{getStepOneVotesCountIndividual}}</b>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              append-icon="search"
              label="Search by nominee name"
              v-model="search.name"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap row v-if="getVotingStepOneIndividual.length">
      <v-flex>
        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="votingItem in filteredVotingData"
            :key="votingItem.category.id"
          >
            <div slot="header">
              <h3>{{votingItem.category.title}}</h3>
            </div>
            <v-card>
              <v-card-text class="grey lighten-3">
                <p>{{votingItem.category.description}}</p>
                <p>Total votes count: <span v-text="countTotalCategoryVotes(votingItem)"></span></p>
              </v-card-text>
              <v-data-table
                :headers="headers"
                :items="votingItem.nominees"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="py-4">
                    <v-avatar><img :src="receiveImgUrl(props.item)" alt="no image"></v-avatar>
                  </td>
                  <td class="py-4">{{ props.item.nominee.name }}</td>
                  <td class="py-4">{{ props.item.votes }}</td>
                  <td class="py-4">{{ props.item.nominee.status }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
    <div v-else ><h3>No votes yet</h3></div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { sort, path, clone } from 'ramda'

export default {
  name: "AwardsVotingStepOne",
  data () {
    return {
       headers: [
        { text: 'Logo', value: 'logoUrl', search: false, sortable: false },
        { text: 'Name', value: 'name', search: false, sortable: true },
        { text: 'Votes', value: 'votes', search: false, sortable: true },
        { text: 'Status', value: 'status', search: false, sortable: true }
      ],
      search: {
         name: ''
      },
      votingData: [],
      filteredVotingData: []
    }
  },
  computed: {
    ...mapGetters([
      'getVotingStepOneIndividual',
      'getStepOneAttendeesCountIndividual',
      'getStepOneVotesCountIndividual'
    ]),
    sortedCategoriesByOrder () {
      const comparator = (a, b) => a.category.order < b.category.order
      return sort(comparator, this.votingData)
    }
  },
  watch: {
    search: {
      handler () {
        this.fetchTableData()
      },
      deep: true
    },
    getVotingStepOneIndividual: {
      handler (newVal) {
        this.votingData = clone(this.getVotingStepOneIndividual)
        this.filterNomineesByName()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'fetchVotingStepOneIndividual',
      'fetchVotingStatisticsStepOneIndividual'
    ]),
    filterNomineesByName () {
      const pattern = new RegExp(this.search.name, 'i')
      const categoriesWithFilteredNominees = this.sortedCategoriesByOrder.map((category) => {
        let filteredNominees = category.nominees.filter((nomineeItem)=>{
          let name = path(['nominee', 'name'], nomineeItem)
          return pattern.test(name)
        })
        category.nominees = filteredNominees
        return category
      })
      this.filteredVotingData = clone(categoriesWithFilteredNominees)
    },
    countTotalCategoryVotes (category) {
      const nomineesList = path(['nominees'], category)
      const categoryVotesCount = nomineesList.reduce((prevValue, currentValue) => {
        return prevValue + currentValue.votes
      }, 0)
      return categoryVotesCount
    },
    receiveImgUrl (item) {
      return (item.nominee.logoUrl) || 'http://via.placeholder.com/250x100.jpg'
    },
    async fetchTableData () {
      await this.fetchVotingStepOneIndividual(path(['name'], this.search))
    },
    async receiveRequiredData () {
      await this.fetchVotingStepOneIndividual()
      this.fetchVotingStatisticsStepOneIndividual()
    }
  },
  created () {
    this.receiveRequiredData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Awards/Voting/StepOneIndividual/index.vue